import { useState } from "react";

export default function TabsMobile() {
  const [activeTab, setActiveTab] = useState(5);

  const handleTab = (index: number): void => {
    if (index === activeTab) {
      setActiveTab(-1);
    } else {
      setActiveTab(index);
    }
  };

  return (
    <div
      id="accordion-collapse"
      className="collapsed block md:hidden mb-20 border p-3 px-7 py-5 rounded-2xl mx-4 md:mx-0 border border-green-600 bg-doctio-lightgreen"
      data-accordion="collapse"
    >
      <div
        className="mb-5 px-4 pb-5 border-b"
        id="accordion-collapse-heading-1"
      >
        <button
          type="button"
          onClick={() => handleTab(0)}
          className="flex items-center justify-between w-full font-medium text-left  text-doctio-green bg-doctio-lightgreen"
          data-accordion-target="#accordion-collapse-body-1"
        >
          <span className="font-bold mb-1 pr-[30px] text-[16px] leading-[1.3]">
            Stort bibliotek af tekstfraser, klikfraser og journalkoncepter
          </span>
          <svg
            data-accordion-icon
            className={`w-6 h-6 rotate-icon ${
              0 === activeTab ? "rotate-active" : ""
            } shrink-0`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5 5 1 1 5"
            />
          </svg>
        </button>
        <div
          id="accordion-collapse-body-1"
          className={`${0 === activeTab ? "collapsed" : ""} collapsible`}
        >
          <div className="mt-2">
            <p className="mb-2 text-[15px]">
              Doctio tilbyder et stort bibliotek med over 400 fraser og
              del-fraser indenfor forskellige sygdomme, symptomer,
              årskontroller, rutinekontroller, procedurer og ordinationer til
              brug i almen praksis, speciallægepraksis og på sygehus. Fraserne
              er skrevet og gennemlæst af læger, og bliver løbende
              speciallægevalideret for at sikre den højeste faglige og juridiske
              kvalitet. Fraser kan øge produktiviteten, behandlingskvaliteten og
              fungere som et læringsredskab, der kan hjælpe med at afdække
              vigtige elementer i konsultationerne. På platformen findes også
              forskellige journalkoncepter som er klar til download og udprint.
            </p>
            <a
              href="/docs/getting-started/introduction/"
              className="text-doctio-dark-green font-bold text-[15px] hover:underline"
            >
              Opret bruger
            </a>
          </div>
        </div>
      </div>

      <div
        className="mb-5 px-4 pb-5 border-b"
        id="accordion-collapse-heading-2"
      >
        <button
          type="button"
          onClick={() => handleTab(1)}
          className="flex items-center justify-between w-full font-medium text-left  text-doctio-green bg-doctio-lightgreen"
          data-accordion-target="#accordion-collapse-body-2"
          aria-expanded="false"
          aria-controls="accordion-collapse-body-2"
        >
          <span className="font-bold mb-1 pr-[30px] text-[16px] leading-[1.3]">
            Opret dine egne fraser, personliggør Doctios fraser og del fraser
            med dit klinikpersonale
          </span>
          <svg
            data-accordion-icon
            className={`w-6 h-6 rotate-icon ${
              1 === activeTab ? "rotate-active" : ""
            } shrink-0`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5 5 1 1 5"
            />
          </svg>
        </button>
        <div
          id="accordion-collapse-body-2"
          className={`${1 === activeTab ? "collapsed" : ""} collapsible`}
          aria-labelledby="accordion-collapse-heading-2"
        >
          <div className="mt-2">
            <p className="mb-2 text-[15px]">
              Måden at journalføre på er en faglig præference og skøn, og derfor
              har vi gjort det muligt at tilpasse fraserne til dit behov. Du har
              hos Doctio mulighed for at oprette dine egne fraser eller redigere
              eksisterende fraser, så de passer nøjagtig til dig. Desuden har du
              mulighed for at sende og modtage fraser mellem kollegaer, samt at
              tilgå Doctios online fraseforum.
            </p>
            <a
              href="/docs/getting-started/introduction/"
              className="text-doctio-dark-green font-bold text-[15px]"
            >
              Opret bruger
            </a>
          </div>
        </div>
      </div>

      <div
        className="mb-5 px-4  pb-5 border-b"
        id="accordion-collapse-heading-3"
      >
        <button
          type="button"
          onClick={() => handleTab(2)}
          className="flex items-center justify-between w-full font-medium text-left  text-doctio-green bg-doctio-lightgreen"
          data-accordion-target="#accordion-collapse-body-3"
          aria-expanded="false"
          aria-controls="accordion-collapse-body-3"
        >
          <span className="font-bold mb-1 pr-[30px] text-[16px] leading-[1.3]">
            Cloudbaseret teknologi der virker på tværs af journalsystemer
          </span>
          <svg
            data-accordion-icon
            className={`w-6 h-6 rotate-icon ${
              2 === activeTab ? "rotate-active" : ""
            } shrink-0`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5 5 1 1 5"
            />
          </svg>
        </button>
        <div
          id="accordion-collapse-body-3"
          className={`${2 === activeTab ? "collapsed" : ""} collapsible`}
          aria-labelledby="accordion-collapse-heading-3"
        >
          <div className="mt-2">
            <p className="mb-2 text-[15px]">
              Doctio gør det muligt at have dine personlige fraser lige ved
              hånden - uanset om din arbejdsplads skifter fra praksis til
              lægevagten, du roterer i uddannelsesstillinger eller bare starter
              et nyt sted. Vores web -og softwareapplikation er desuden
              uafhængig af forskellige journalsystemer, så hvis du skifter
              journalsystem mellem Clinea, XMO, Sundhedsplatformen, EPJ etc.,
              eller regionen skifter system, mister du ikke dine fraser. Du har
              ubegrænset plads til dine fraser.
            </p>
            <a
              href="/docs/getting-started/introduction/"
              className="text-doctio-dark-green font-bold text-[15px] hover:underline"
            >
              Opret bruger
            </a>
          </div>
        </div>
      </div>

      <div
        className="mb-5 px-4 pb-5 border-b"
        id="accordion-collapse-heading-3"
      >
        <button
          type="button"
          onClick={() => handleTab(3)}
          className="flex items-center justify-between w-full font-medium text-left  text-doctio-green bg-doctio-lightgreen"
          data-accordion-target="#accordion-collapse-body-3"
          aria-expanded="false"
          aria-controls="accordion-collapse-body-3"
        >
          <span className="font-bold mb-1 pr-[30px] text-[16px] leading-[1.3]">
            Dynamiske fraser med indbygger logik og DoctioAssist med
            autosuggestion
          </span>
          <svg
            data-accordion-icon
            className={`w-6 h-6 rotate-icon ${
              3 === activeTab ? "rotate-active" : ""
            } shrink-0`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5 5 1 1 5"
            />
          </svg>
        </button>
        <div
          id="accordion-collapse-body-3"
          className={`${3 === activeTab ? "collapsed" : ""} collapsible`}
          aria-labelledby="accordion-collapse-heading-3"
        >
          <div className="mt-2">
            <p className="mb-2 text-[15px]">
              Vi fokuserer på brugervenlighed og ønsker at gøre journalføring
              let gennem automatiseret makrofunktion med autosuggestion (vi
              kalder det Smart-Makro). Smart-Makro kan hurtigt og tidsbesparende
              indsætte fraser eller del-fraser i dit journalsystem vha. et
              selvvalgt tastaturklik. Hvis du ikke helt kan huske det præcise
              navn på frasen, som du prøver at indsætte, vil den indbyggende
              autosuggestion hjælpe dig med at foreslå den frase, du prøver at
              indsætte.
            </p>
            <a
              href="/docs/getting-started/introduction/"
              className="text-doctio-dark-green font-bold text-[15px] hover:underline"
            >
              Opret bruger
            </a>
          </div>
        </div>
      </div>

      <div className="px-4" id="accordion-collapse-heading-3">
        <button
          type="button"
          onClick={() => handleTab(4)}
          className="flex items-center justify-between w-full font-medium text-left  text-doctio-green bg-doctio-lightgreen"
          data-accordion-target="#accordion-collapse-body-3"
          aria-expanded="false"
          aria-controls="accordion-collapse-body-3"
        >
          <span className="font-bold mb-1 pr-[30px] text-[16px] leading-[1.3]">
            GDPR sikkert og øget juridisk sikkerhed
          </span>
          <svg
            data-accordion-icon
            className={`w-6 h-6 rotate-icon ${
              4 === activeTab ? "rotate-active" : ""
            } shrink-0`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5 5 1 1 5"
            />
          </svg>
        </button>
        <div
          id="accordion-collapse-body-3"
          className={`${4 === activeTab ? "collapsed" : ""} collapsible`}
          aria-labelledby="accordion-collapse-heading-3"
        >
          <div className="mt-2">
            <p className="mb-2 text-[15px]">
              Vores platform er sikker, og du kan uden problemer bruge Doctio på
              interne computere i private klinikker, på sygehuset eller uden for
              landets grænser. Vi behandler ikke patient-personfølsomme data.
              Doctio kan være være med til at øge din juridiske sikkerhed. I et
              travlt system kan det ske, at man ikke får journalført allerede
              givne informationer eller undersøgelser grundet tidspres, hvilket
              kan resultere i klager. Fraser kan sikre, at man får adspurgt om,
              undersøgt for og givet relevante informationer og ultimativt får
              det journalført sufficient. Fraserne skal jf.
              Journalføringsbekendtgørelsen tilpasses, så teksten passer til den
              konkrete patientkontakt, og der ikke fremgår irrelevante
              oplysninger.
            </p>
            <a
              href="/docs/getting-started/introduction/"
              className="text-doctio-dark-green font-bold text-[15px] hover:underline"
            >
              Opret bruger
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
